<div class="auth-status">
  <i class="fas fa-times fa-2x text-danger" aria-hidden="true"></i>
  <h2 class="auth-status-title">{{ "login.error" | translate }}</h2>
  <p class="auth-status-text">{{ "login.againInfo" | translate }}</p>
  <a class="auth-status-link" [routerLink]="['/login']">{{ "login.again" | translate }}</a>
</div>
